// Copyright (C) Okahu Inc 2023-2024. All rights reserved.

// the sole purpose is to treat null, undefined and empty string values as equal.
// return true if the keys are not equal.
export const shallowComparator = (
  key1: string | null | undefined | boolean | string[],
  key2: string | null | undefined | boolean | string[]
) => {
  let copyKey1 = key1;
  let copyKey2 = key2;
  if (typeof copyKey1 === 'string' && copyKey1.length === 0) copyKey1 = null;
  if (typeof copyKey2 === 'string' && copyKey2.length === 0) copyKey2 = null;
  if (typeof copyKey1 === 'undefined') copyKey1 = null;
  if (typeof copyKey2 === 'undefined') copyKey2 = null;

  if (Array.isArray(copyKey1) && Array.isArray(copyKey2)) {
    if (copyKey1.length !== copyKey2.length) return true;
    const sortedA = [...copyKey1].sort();
    const sortedB = [...copyKey2].sort();
    return !sortedA.every((val, i) => val === sortedB[i]);
  }

  return copyKey1 !== copyKey2;
};

export const strToArray = (s: string | null | undefined): string[] => {
  if (!s) return [];
  return s.split(',').filter(Boolean);
};
